import React, { useContext, useEffect } from "react";
import ManufacturerContext from "./ManufacturerContext";

interface IManufacturerProps {
  applicationId: string;
}

type ManufacturerContextValue = NonNullable<React.ContextType<typeof ManufacturerContext>>;

export const useManufacturer = (): ManufacturerContextValue => {
  const context = useContext(ManufacturerContext);

  if (!context) {
    throw new Error(
      "useManufacturer() could not find ManufacturerContext value. Please ensure the component is wrapped in a <ManufacturerContext.Provider>."
    );
  }

  return context;
};

/**
 * @deprecated The `withManufacturer` HOC is deprecated. Please use the `useManufacturer` hook instead.
 */
export default function withManufacturer<P extends IManufacturerProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof IManufacturerProps>> {
  const WithManufacturer = (props: Omit<P, keyof IManufacturerProps>) => {
    useEffect(() => {
      console.warn(
        `Deprecation Warning: The HOC 'withManufacturer' is deprecated. Please use the 'useManufacturer' hook instead in '${
          Component.displayName || Component.name || "Component"
        }'.`
      );
    }, []);

    const context = useManufacturer();

    const allProps = { ...props, ...context };

    return <Component {...(allProps as P)} />;
  };

  WithManufacturer.displayName = `withManufacturer(${Component.displayName || Component.name || "Component"})`;

  return WithManufacturer;
}
